<template>
    <MustConsent :storeKey="'gmaps'" @update:consented="initMap()">

        <template v-slot:description>
            <div class="p-4 text-white text-center">{{ __('maps.consent-description') }}</div>
        </template>

        <div v-if="key" class="comp-gmap">
            <div ref="gmap" style="min-height: 400px; min-width: 100%;"><!-- content from g-maps --></div>
        </div>
        <div v-else>
            {{ __('maps.no-key-present') }}
        </div>

    </MustConsent>
</template>

<script>
    import MustConsent from "@/Components/MustConsent";
    import { __ } from "@/locale";

    let map = null;
    let marker = null;

    export default {
        // a single marker on the map, multi-instanceable
        // not possible and not required make this reactive
        // removing marker is not possible when reactive
        gMapsMarker: null,
        gMapsMap: null,

        components: {
            MustConsent,
        },
        props: {
            latitude: {
                default: 50.94036,
                type: Number,
                required: true,
            },
            longitude: {
                default: 11.5966752,
                type: Number,
                required: true,
            },
            mapSettings: {
                type: Object,
                default: {
                    zoom: 17,
                    zoomControl: true,
                    mapTypeControl: true,
                    scaleControl: true,
                    streetViewControl: true,
                    rotateControl: true,
                    fullscreenControl: true,
                },
            }
        },
        data() {
            return {
                __,
                key: this.$page.props.gmapsApiKey,
            }
        },
        watch: {
            latitude(newVal, oldVal) {
                if(newVal) {
                    this.addMarker(newVal, this.longitude);
                }
            },
            longitude(newVal) {
                if(newVal) {
                    this.addMarker(this.latitude, newVal);
                }
            }
        },
        methods: {
            initMap() {
                console.log('init map', this.latitude, this.longitude);
                this.prepareMap({
                    lat: this.latitude,
                    lng: this.longitude,
                    zoom: this.zoom || 10,
                });
            },

            prepareMap(options) {
                let $gmapScript = document.querySelector('script#gmaps-api');

                if(!$gmapScript) {
                    let callback = 'initMapsApi';
                    let $script = document.createElement('script');
                        $script.id = 'gmaps-api';
                        $script.src = `https://maps.googleapis.com/maps/api/js?key=${this.key}&callback=${callback}`;
                    document.body.append($script);
                    // Event triggers, in `app.js`, from googles Callback
                    window.addEventListener('maps.api-loaded', () => {
                        this.renderMap(options);
                    });
                    return;
                }
                this.renderMap(options);
            },

            renderMap(options) {
                window.setTimeout(() => {
                    this.gMapsMap = new google.maps.Map(this.$refs.gmap, {
                        center: {lat: options.lat, lng: options.lng},
                        zoom: options.zoom,
                        zoomControl: true,
                        mapTypeControl: true,
                        scaleControl: true,
                        streetViewControl: true,
                        rotateControl: true,
                        fullscreenControl: true,
                        // mapTypeId: "satellite",
                    });
                    // TODO: enable setting and changing settings while running, also from outside
                    this.gMapsMap.setOptions({
                        styles: [
                            {
                                featureType: "poi",
                                stylers: [
                                    { visibility: "off" }
                                ]
                            }
                        ]
                    });

                    if(this.latitude && this.longitude) {
                        this.addMarker(this.latitude, this.longitude);
                        this.$emit('update:location',
                            { detail: {lat: this.latitude, lng: this.longitude}
                            });
                    }

                    this.gMapsMap.addListener("click", e => {
                        this.addMarker(e.latLng.lat(), e.latLng.lng());
                        this.$emit('update:location', { detail: {lat: e.latLng.lat(), lng: e.latLng.lng()} });
                    });
                }, 200);
            },

            addMarker(lat, lng, pan = true) {
                const location = {lat, lng};
                if(this.gMapsMarker) {
                    // reset old marker
                    this.gMapsMarker.setMap(null);
                }

                this.gMapsMarker = new google.maps.Marker({
                    position: location,
                    map: this.gMapsMap ,
                });

                if(pan) {
                    this.gMapsMap.panTo(location);
                }
            },

            getGeolocation() {
                console.groupCollapsed('Geolocation Test');
                const options = {
                    maximumAge: 50000,
                    timeout: 20000,
                    enableHighAccuracy: false
                }
                console.log({options});

                function success(pos) {
                    const crd = pos.coords;

                    console.log('Your current position is:');
                    console.log(`Latitude : ${crd.latitude}`);
                    console.log(`Longitude: ${crd.longitude}`);
                    console.log(`More or less ${crd.accuracy} meters.`);
                    console.groupEnd()
                }

                function error(err) {
                    console.warn(`ERROR(${err.code}): ${err.message}`);
                    console.groupEnd()
                }

                navigator.geolocation.getCurrentPosition(success, error, options);

            }
        }
    }
</script>
